import {createStore, createLogger} from 'vuex'
import user from './modules/user';
import app from './modules/app';

const index = createStore({
    modules: {
        user,
        app,
    },
    plugins: [createLogger()]
});

export default index;
